import { render, staticRenderFns } from "./ActivableProductsView.vue?vue&type=template&id=6994ff10&"
import script from "./ActivableProductsView.vue?vue&type=script&lang=js&"
export * from "./ActivableProductsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports